import React from 'react';
import NextLink from '../NextLink';
import { LanguageSwitcherPropsTypes } from './LanguageSwitcher.types';
const generateLanguageLinks = ({
  items,
  currentLocale
}: {
  items: any[];
  currentLocale: string;
}) => items?.filter(lang => lang?.languageCode).sort((a, b) => new Date(a?.sys?.firstPublishedAt).getTime() - new Date(b?.sys?.firstPublishedAt).getTime()).map(lang => <NextLink className={`mx-[0.5rem] rounded-[0.2rem] bg-[#F9F9F9] font-[200] text-[#25282A] transition-colors duration-300 ease-in-out first:ml-[0rem] hover:bg-[#ffbc80] hover:font-[200] hover:text-[#25282A] ${lang.languageCode.toLowerCase() === currentLocale ? 'bg-primary font-[500] text-[#fff]' : ''}`} href={`/news/${lang.slug}`} locale={lang.languageCode.toLowerCase()} key={`${lang?.sys?.id}-translations`}>
        &nbsp;{lang.languageCode}&nbsp;
      </NextLink>);
const LanguageSwitcher: React.FC<LanguageSwitcherPropsTypes> = ({
  post
}) => {
  const currentLocale = post?.languageCode?.toLowerCase() || 'en'; // Current locale based on the post

  const translations = post?.languageCode === 'EN' ? post?.translationsCollection?.items : post?.linkedFrom?.postCollection?.items?.[0]?.translationsCollection?.items;
  const defaultSlug = post?.languageCode === 'EN' ? post?.slug : post?.linkedFrom?.postCollection?.items?.[0]?.slug;
  return <>
      {/* Default English Link */}
      <NextLink href={`/news/${defaultSlug}`} className={`mx-[0.5rem] rounded-[0.2rem] bg-[#F9F9F9] font-[200] text-[#25282A] transition-colors duration-300 ease-in-out first:ml-[0rem] hover:bg-[#ffbc80] hover:font-[200] hover:text-[#25282A] ${currentLocale === 'en' ? 'bg-primary font-[500] text-[#fff]' : ''}`} data-sentry-element="NextLink" data-sentry-source-file="LanguageSwitcher.tsx">
        &nbsp;EN&nbsp;
      </NextLink>

      {/* Language Translations */}
      {generateLanguageLinks({
      items: translations || [],
      currentLocale
    })}
    </>;
};
export default LanguageSwitcher;